import classNames from "classnames";
import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";
import * as React from "react";

const RPGIcon = ({
    icon,
    withClass,
    whenClicked,
}: {
    icon: ERPGIcon;
    withClass?: string;
    whenClicked?: (
        event: React.MouseEvent<HTMLSpanElement, MouseEvent>
    ) => void;
    showIconName?: boolean;
}) => {
    return (
        <span
            id={`rpgIcon_${ERPGIcon[icon]}`}
            onClick={whenClicked}
            className={classNames("ra", `ra-${ERPGIcon[icon]}`, withClass)}
        />
    );
};

export default RPGIcon;

export type ERPGIconName = keyof typeof ERPGIcon;

export function GetRPGIcon(name: string) {
    const result = ERPGIcon[name as ERPGIconName];
    return result;
}

export function GetRPGIconNames() {
    const names = Object.keys(ERPGIcon).filter(
        (k: any) => typeof ERPGIcon[k] === "number"
    ) as string[];

    return names;
}
